<template>
    <div class="n-header-3-1 translucent" @mouseover="mouseoverEvent" @mouseout="mouseoutEvent" :class="{active:menuActive||leftActive,shrinked:shrinked,opaque:opaque}" style="transform: translateY(0px); transition: transform 0.3s linear;">
        <div class="n-header-outer-wrapper">
            <div class="n-header-inner-wrapper">
                <!--     中间logo       -->
                <a name="Logo" href="" title="嘉宏集团" class="n-header-logo">
                    <img src="@/assets/logo_top.png" alt="">
                </a>
                <div class="n-hamburger-menu" @click="minMenuClick">
                    <div class="n-hamburger-menu-inner">
                        <i :class="leftActive?'n-header-crossing-icon':'n-hamburger-menu-bars'">
                        </i>
                    </div>
                </div>
                <div v-if="isMinified&&leftActive" class="n-header-menu">
                    <ul class="n-header-menu-items">
                        <li v-for="(item,index) in headerConfig.menu" :key="index" class="n-header-menu-item" @click="leftMenuClick(item)">
                            <div class="n-header-menu-item-inner">
                                <i class="n-header-crossing-icon" :class="{'active':item.active}"></i>
                                <div>{{item.text}}</div>
                            </div>
                            <ul class="n-header-menu-item-sub-items " :class="{'n-header-menu-item-sub-items-active':item.active}">
                                <li v-for="(subItem,subIndex) in item.menu" :key="subIndex" class="n-header-menu-sub-item" @click.stop="routLinkTo(subItem)">
                                    <a href="javascript:" :name="subItem.text" data-tracking-params="Public_event,Navigation_Button,Click,${name}">
                                        <i class="n-header-menu-sub-item-arrow-icon"></i>
                                        <span class="n-header-menu-sub-item-text">{{subItem.text}}</span>
                                        <span class="n-header-menu-sub-item-slogan"></span>
                                    </a>
                                </li>
                                <li class="n-header-menu-sub-item n-header-menu-sub-item-delimiter">
                                </li>
                            </ul>
                        </li>
                        <li class="n-header-menu-item n-header-menu-item-app-download">
                            <a class="n-header-menu-item-inner" href="https://home.myyscm.com/czjh" name="招采平台">
                                <img class="n-header-menu-app-download-icon" src="">
                                <div>招采平台</div>
                            </a>
                        </li>
                        <li class="n-header-menu-item n-header-menu-item-app-download" @click="joinClick">
                            <a class="n-header-menu-item-inner" href="javascript:" name="加入嘉宏">
                                <img class="n-header-menu-app-download-icon" src="">
                                <div>加入嘉宏</div>
                            </a>
                        </li>
                    </ul>
                    <div class="n-header-buttons-language-and-account-wrapper" @click="exchangeClick">
                        <div class="n-header-buttons-fellow nin-button">
                            以旧换新
                        </div>
                        <div class="n-header-buttons-more-options-panel"></div>
                    </div>
                </div>
                <div class="n-header-menu-outter">
                    <!--      导航栏左侧菜单        -->
                    <ul class="n-header-top-menu">
                        <li class="n-header-top-menu-item  " v-for="(item,index) in headerConfig.menu" :key="index" @click="menuClick(item)">
                            {{item.text}}
                        </li>
                    </ul>
                    <!--      导航栏弹窗关闭按钮        -->
                    <i class="n-header-crossing-icon n-header-top-menu-close" @click="closeMenu"></i>
                    <div class="n-header-menu">
                        <!--    左侧弹窗            -->
                        <div class="n-header-menu-left-pannel">
                            <ul class="n-header-menu-item" :class="{active:menuId===item1.id}" v-for="(item1,index1) in headerConfig.menu" :key="index1">
                                <li class="n-header-menu-sub-item"  v-for="(subItem,subIndex) in item1.menu" :key="subIndex" @mouseover="showImage(subItem)" @click.stop="routLinkTo(subItem)">
                                    <a href="javascript:">
                                        <i class="n-header-menu-sub-item-arrow-icon"></i>
                                        <span class="n-header-menu-sub-item-text">{{subItem.text}}</span>
                                        <span class="n-header-menu-sub-item-slogan"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="n-header-buttons">
                    <div class="n-header-buttons-language-and-account-wrapper ">
                        <a class="n-header-buttons-fellow" href="https://home.myyscm.com/czjh" target="_blank">
                            招采平台
                        </a>
                        <div class="n-header-buttons-fellow" @click="joinClick">
                            加入嘉宏
                        </div>
                    </div>
                    <a @click="exchangeClick" href="javascript:" title="以旧换新" class="n-header-buttons-exchange">
                        以旧换新
                    </a>
                    <a @click="applyClick" href="javascript:" title="预约看房" class="n-header-buttons-promoted">
                        预约看房
                    </a>
                </div>
            </div>
        </div>
        <div class="n-header-menu-right-pannel">
            <div class="n-header-menu-desktop-right-panel" :class="{active:imgName.length>0}" >
                <img v-if="imgName.length>0" class="n-header-menu-desktop-right-panel-background" :src="require('@/assets/'+ imgName)">
            </div>
        </div>
    </div>
</template>

<script>
import {isMobile} from "../../utils/validate";

export default {
    name: 'top-nav',
    props: {
        shrinked:Boolean,
        isAuto:Boolean
    },
    data () {
      return {
          isMinified: false,
          menuActive: false,
          subMenu:[],
          menuId:'',
          imgName:'',
          opaque:false,
          leftActive:false,
          headerConfig: {
              menu: [
                  {
                      id: "aboutnio",
                      text: "走进嘉宏",
                      type: "regular",
                      menu: [
                          {
                              id: "about",
                              text: "嘉宏介绍",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              "preview": {
                                  image: "home_right/jhjs.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "honor",
                              text: "企业荣誉",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              "preview": {
                                  image: "home_right/qyry.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "visioncar",
                              text: "发展历程",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              "preview": {
                                  image: "home_right/fzlc.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "corporate",
                              text: "企业文化",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              preview: {
                                  image: "home_right/qywh.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "news",
                              text: "新闻中心",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              preview: {
                                  image: "home_right/xwzx.jpg",
                                  type: "image"
                              }
                          }
                      ]
                  },
                  {
                      id: "models",
                      text: "多元业务",
                      type: "model",
                      menu: [
                          {
                              id: "dwell",
                              text: "住宅开发",
                              type: "svg",
                              slogan: "",
                              "src": "",
                              href: "#",
                              preview: {
                                  image: "home_right/zzkf.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "business",
                              text: "商业开发",
                              type: "svg",
                              slogan: "",
                              "src": "",
                              href: "#",
                              preview: {
                                  image: "home_right/sykf.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "real",
                              text: "物业运营",
                              type: "svg",
                              slogan: "",
                              "src": "",
                              href: "#",
                              "higherLogo": false,
                              "widerLogo": true,
                              preview: {
                                  image: "home_right/wyyy.jpg",
                                  type: "image"
                              }
                          },
                          {
                              id: "hotel",
                              text: "酒店经营",
                              type: "svg",
                              slogan: "",
                              "src": "",
                              href: "#",
                              preview: {
                                  image: "home_right/jdjy.jpg",
                                  type: "image"
                              }
                          }
                      ]
                  },
                  {
                      id: "beyondthecar",
                      text: "客户服务",
                      type: "regular",
                      menu: [
                          {
                              id: "elegance",
                              text: "风华荟",
                              type: "regular",
                              href: "#",
                              slogan: "",
                              preview: {
                                  image: "elegance/banner.jpg",
                                  type: "image"
                              }
                          },
                          // {
                          //     id: "service",
                          //     text: "客服中心",
                          //     type: "regular",
                          //     href: "#",
                          //     slogan: "",
                          //     preview: {
                          //         image: "home_right/kfzx.jpg",
                          //         type: "image"
                          //     }
                          // }
                      ]
                  }
              ]
          },
          activeRoute: '/home',
          searchKeyWord: ''
      }
    },
    watch: {
      $route (to, from) {
          console.log('activeRoute==',to.path)
         this.activeRoute = to.path
      }
    },
    mounted() {
        this.activeRoute = this.$route.path
        this.resizeEvent()
        window.addEventListener("resize", this.resizeEvent)
    },
    methods: {
        resizeEvent(){
            let windowWidth = window.innerWidth
            this.isMinified = windowWidth < 1024
            if(this.isMinified && this.menuActive){
                this.leftActive = true
            }
        },
        mouseoverEvent(){
            if(this.shrinked && this.isAuto){
                this.opaque = true
            }
        },
        mouseoutEvent(){
            if(this.shrinked && this.isAuto){
                this.opaque = false
            }
        },
        handleScroll(event) {
            // 阻止滚动事件冒泡
            event.stopPropagation();
            // 你的滚动处理逻辑
        },
        menuClick(item){
            this.menuActive = true
            this.menuId = item.id
            this.subMenu = item.menu
        },
        closeMenu(){
            console.log("closeMenu")
            this.menuActive = false
            if(this.leftActive){
                this.leftActive = false
            }
        },
        minMenuClick(){
            this.leftActive = !this.leftActive
            if(!this.leftActive){
                this.menuActive = false
            }
        },
        leftMenuClick(item){
            this.headerConfig.menu.forEach(item1=>{
                if(item1.id != item.id){
                    item1['active'] = false
                }
            })
            item['active'] = !item['active']
            this.$forceUpdate()
        },
        showImage(subItem){
            this.imgName = subItem.preview.image
        },
        routLinkTo(subItem){
            if(this.activeRoute.indexOf(subItem.id) != -1){
                // 已经在页面
                window.location.reload()
                return
            }
            this.$router.push({
                path:'/'+subItem.id
            })
        },
        joinClick(){
            this.$router.push('/join')
        },
        exchangeClick(){
            this.$router.push('/exchange')
        },
        applyClick(){
            this.$router.push('/apply')
        }
    }
}
</script>

<style lang="scss">

</style>
